import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as ReviewTypesActions from '../review-types/review-types.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class ReviewTypesStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new ReviewTypesActions.ReviewTypesRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.REVIEW_TYPES, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new ReviewTypesActions.ReviewTypesCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new ReviewTypesActions.ReviewTypesUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new ReviewTypesActions.ReviewTypesDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new ReviewTypesActions.ReviewTypesRefresh());
          break;
      }
    });
  }
}
